export default __webpack_public_path__ + "cbd2fcc0eb06c27d62a42ec3bf4aefa3.png";